import React from 'react'
import Header from '../../../Components/Header'

function Datasheet({ heading_size = 2 }) {
    return (
        <>
            <Header text={"Datasheet"} level={heading_size} />
            <div>
                Data
            </div>
        </>
    )
}

export default Datasheet